import React from 'react';
import experiments from '../experiments';
import { useExpEnabled } from '../user_hooks';
import I18n from 'i18n-js';
import { MParticleEventName } from '../elog/mparticle_types';
import { trackEvent } from '../elog/mparticle_tracker';
import classNames from 'classnames';
import { getItem } from '../storage_wrapper';

interface IProps {
  setListViewState?: (val: boolean) => void;
  loading?: boolean;
}

export default function ListViewToggle({
  setListViewState,
  loading = false,
}: IProps) {
  if (!useExpEnabled(experiments.LIST_VIEW_IN_SEARCH)) return null;

  const listViewState = getItem('LIST_VIEW_STATE') || 'false';

  const onClick = (enabled) => {
    setListViewState(enabled);

    const clickTrackingData = {
      componentName: 'ListViewToggle',
      eventName: MParticleEventName.ClickedListViewToggle,
      usingListView: enabled,
    };

    trackEvent(clickTrackingData);
  };

  const classes = classNames(
    'list-view-toggle button-group button-group--rounded',
    { 'list-view-toggle--loading': loading },
  );

  return (
    <div className={classes}>
      <button
        className={classNames(
          'button-group__button',
          { 'button-group__button--selected': listViewState === 'true' },
        )}
        onClick={() => onClick(true)} type="button">
        {I18n.t('commons.marketplaceViewStates.list')}
      </button>
      <button
        className={classNames(
          'button-group__button',
          { 'button-group__button--selected': listViewState === 'false' },
        )}
        onClick={() => onClick(false)} type="button">
        {I18n.t('commons.marketplaceViewStates.grid')}
      </button>
    </div>
  );
}
